import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Strategy } from "../domain/strategy";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root',
})
export class StrategyService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/strategy`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    getStrategyList() {
        this.loadingTask.activateLoading();
        return this.http.get(this.serviceUrl, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getStrategyList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Strategy[]) => {
                return response.map((item: Strategy) => {
                    return Strategy.mapFromJSON(item);
                });
            }));
    }

    getStrategyForOrder(id: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${id}/Order`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getStrategyForOrder')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Strategy) => {
                return Strategy.mapFromJSON(response);
            }));
    }

    getStrategyById(id: number) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${id}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getStrategyById')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Strategy) => {
                return Strategy.mapFromJSON(response);
            }));
    }

    toggleFavorite(strategy: Strategy) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/${strategy.Id}/favorite`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('toggleFavorite')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    createStrategyDemand(strategy: Strategy) {
        this.loadingTask.activateLoading();

        const body = Object.assign({}, strategy) as any;
        // body.Portfolio.SamplingPointZipCode = strategy.Portfolio.SamplingPoint.ZipCode;
        // body.Portfolio.SamplingPointAddress = strategy.Portfolio.SamplingPoint.Address;
        // body.Portfolio.SamplingPointName = strategy.Portfolio.SamplingPoint.Name;
        // body.Portfolio.SamplingPointCity = strategy.Portfolio.SamplingPoint.City;

        body.Portfolio.AlternateContacts = strategy.Portfolio.AlternateContactList;
        // TEMP 
        // body.Portfolio.ClientCode = 'LK008681';
        // body.Portfolio.ClientName = 'LA CHATTE A DD';
        //
        return this.http.post(`${this.serviceUrl}`, JSON.stringify(body), this.generateHeader()).pipe(
            catchError(this.handleError<any>('createStrategyDemand')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: number) => {
                return response;
            }));
    }

    updateStrategyDemand(strategy: Strategy) {
        this.loadingTask.activateLoading();

        const body = Object.assign({}, strategy) as any;
        body.Portfolio.AlternateContacts = strategy.Portfolio.AlternateContactList;

        return this.http.put(`${this.serviceUrl}/${strategy.Id}`, JSON.stringify(body), this.generateHeader()).pipe(
            catchError(this.handleError<any>('createStrategyDemand')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: number) => {
                return response;
            }));
    }

    deleteStrategyDemand(strategy: Strategy) {
        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${strategy.Id}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('deleteStrategyDemand')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
}